import React from "react";
import FirstName from './firstName/firstName.js';
import LastName from './lastName/lastName.js';
import './userName.css';

export default () => (
  <span className="user_name">
    <FirstName/>
  </span>
);


// WEBPACK FOOTER //
// ./src/components/userName/userName.js